import script from "./department-installation-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./department-installation-chart.vue?vue&type=script&lang=ts&setup=true"

import "./department-installation-chart.vue?vue&type=style&index=0&id=435573fc&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-435573fc"]])

export default __exports__